/** Shared app shell layout — desktop design preserved; mobile uses app chrome. */

/**
 * Content area under fixed mobile top bar + above bottom tab bar.
 * Desktop (lg+): 280px sidebar offset, no top/bottom chrome padding.
 */
export const APP_SHELL_CLASS =
  "min-h-screen bg-[#F6F8FB] font-sans ml-0 pt-[3.75rem] pb-[calc(4.25rem+env(safe-area-inset-bottom,0px))] lg:pt-0 lg:pb-0 lg:ml-[280px] transition-all duration-300";

/**
 * Full-bleed builders (Create/Edit Form) — no mobile top/bottom chrome padding.
 * App hides MobileAppBar + BottomNav on these routes.
 */
export const APP_SHELL_IMMERSIVE_CLASS =
  "min-h-screen bg-[#F6F8FB] font-sans ml-0 lg:ml-[280px] transition-all duration-300";

/**
 * Standard page content wrapper — use on EVERY workspace page.
 * Same padding + max-width so Dashboard / Forms / Queries / Notes / Profile /
 * Support / Plans align.
 *
 * Do NOT add sticky headers with -mx / extra py — that breaks visual padding
 * vs other pages. Keep title blocks as a plain mb-8 header inside this wrapper.
 */
export const APP_SHELL_INNER_CLASS =
  "w-full max-w-[1600px] mx-auto p-3 sm:p-6 lg:p-10 box-border";

/** Space for fixed mobile top bar (lg:hidden). */
export const APP_SHELL_MOBILE_PAD = "pt-[3.75rem] lg:pt-0";

export const MOBILE_TOPBAR_HEIGHT = "3.75rem"; // 60px — native denser bar
export const MOBILE_BOTTOMBAR_HEIGHT = "4.25rem"; // ~68px + safe area handled in APP_SHELL

/** Sticky offset under mobile app bar */
export const STICKY_UNDER_APPBAR =
  "sticky top-[3.75rem] lg:top-0 z-20 bg-[#F6F8FB]";

/** Page title block → first content section */
export const PAGE_HEADER_CLASS = "mb-6 sm:mb-8";

/** Vertical rhythm between major page sections */
export const PAGE_SECTION_CLASS = "mb-6 sm:mb-8";

/** Default gap for card / column grids */
export const PAGE_GRID_GAP_CLASS = "gap-4 sm:gap-6";

/** Default gap for multi-column layouts (main + sidebar) */
export const PAGE_LAYOUT_GAP_CLASS = "gap-4 sm:gap-6";

/** Mobile-app style page title */
export const PAGE_TITLE_CLASS =
  "text-xl sm:text-2xl lg:text-3xl font-bold text-[#0B1C2D] tracking-tight";

/** Mobile-app style page subtitle */
export const PAGE_SUBTITLE_CLASS = "text-gray-500 text-xs sm:text-sm mt-1";

/** Primary CTA full-width on phones */
export const PAGE_PRIMARY_CTA_CLASS =
  "w-full sm:w-auto bg-[#0B1C2D] hover:bg-[#152a40] text-white px-5 py-3 rounded-xl font-bold shadow-lg flex items-center justify-center gap-2 transition-all active:scale-[0.98]";


/** Public website content width: 95% mobile, 90% desktop */
export const SITE_CONTAINER_CLASS =
  "mx-auto w-[95%] md:w-[90%]";
